import { useEffect, useState } from "react";
import api from "../../lib/api";

function fmt(n) {
    return new Intl.NumberFormat("en-KE", { maximumFractionDigits: 2 }).format(n || 0);
}

const KIND_COLOR = {
    TOPUP: "bg-emerald-100 text-emerald-700",
    VAS_SALE: "bg-pink-100 text-pink-700",
    PROCUREMENT: "bg-cyan-100 text-cyan-700",
    CREDIT_DISBURSE: "bg-amber-100 text-amber-700",
};

export default function SalesTab() {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("ALL");

    useEffect(() => {
        const url = filter === "ALL" ? "/transactions?limit=200" : `/transactions?limit=200&kind=${filter}`;
        api.get(url).then((r) => setItems(r.data));
    }, [filter]);

    return (
        <div className="space-y-6" data-testid="sales-page">
            <div className="flex items-end justify-between flex-wrap gap-3">
                <div>
                    <h2 className="font-display text-3xl font-extrabold text-onego-navy">Sales history</h2>
                    <p className="text-slate-600">All transactions with receipts and references.</p>
                </div>
                <div className="flex gap-2">
                    {["ALL", "VAS_SALE", "TOPUP", "PROCUREMENT", "CREDIT_DISBURSE"].map((k) => (
                        <button
                            key={k}
                            onClick={() => setFilter(k)}
                            className={`px-3 py-2 rounded-full text-xs font-bold border transition ${filter === k ? "bg-onego-navy text-white border-onego-navy" : "border-slate-200 text-slate-600 hover:border-onego-navy"}`}
                            data-testid={`sales-filter-${k}`}
                        >
                            {k.replace("_", " ")}
                        </button>
                    ))}
                </div>
            </div>

            <div className="og-card overflow-hidden">
                <table className="w-full text-sm" data-testid="sales-table">
                    <thead className="bg-slate-50 text-slate-500 uppercase text-xs tracking-widest">
                        <tr>
                            <th className="text-left px-5 py-3">Date</th>
                            <th className="text-left px-5 py-3">Description</th>
                            <th className="text-left px-5 py-3">Type</th>
                            <th className="text-left px-5 py-3">Ref</th>
                            <th className="text-right px-5 py-3">Amount</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {items.length === 0 && (
                            <tr><td colSpan={5} className="px-5 py-8 text-center text-slate-500">No transactions yet.</td></tr>
                        )}
                        {items.map((t) => (
                            <tr key={t.id} data-testid={`sales-row-${t.id}`}>
                                <td className="px-5 py-3 text-slate-600">{new Date(t.created_at).toLocaleString()}</td>
                                <td className="px-5 py-3 font-semibold text-onego-navy">{t.meta?.description || t.kind}</td>
                                <td className="px-5 py-3"><span className={`og-chip ${KIND_COLOR[t.kind] || ""}`}>{t.kind.replace("_", " ")}</span></td>
                                <td className="px-5 py-3 text-slate-500">{t.ref}</td>
                                <td className="px-5 py-3 text-right font-display font-bold text-onego-navy">KES {fmt(t.amount)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
